var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(!_vm.waitForData) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "citizenshipGov"
    }
  }, [_vm._v("Státní příslušnost (občanství):")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.citizenship),
      expression: "client.citizenship"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "citizenshipGovHelp",
      "id": "citizenshipGov",
      "data-testid": "registration-citizenship"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.citizenship = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.citizenship), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.name_cz) + " - " + _vm._s(row.code) + " - " + _vm._s(row.name_en))])
  })), _vm._v(" "), (_vm.clientError.citizenship) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "citizenshipError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.citizenship.message))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "personalid"
    }
  }, [_vm._v("Rodné číslo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.client.p_i_n),
      expression: "client.p_i_n",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "personalidHelp",
      "id": "personalid",
      "data-testid": "registration-pin"
    },
    domProps: {
      "value": (_vm.client.p_i_n)
    },
    on: {
      "change": _vm.clientPINChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.p_i_n = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.pinDecodeWarning !== null) ? _c('div', {
    attrs: {
      "data-testid": "registration-pin-warnings"
    }
  }, _vm._l((_vm.pinDecodeWarning), function(warning, index) {
    return _c('div', [_c('small', {
      staticClass: "form-text text-danger"
    }, [_vm._v(_vm._s(warning.text))]), _vm._v(" "), (index === 'duplicate') ? _vm._l((warning.clients), function(client) {
      return _c('small', {
        staticClass: "form-text text-danger"
      }, [_vm._v(" - " + _vm._s(client.full_name))])
    }) : _vm._e()], 2)
  })) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Jméno:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.first_name),
      expression: "client.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "firstnameHelp",
      "id": "firstname",
      "data-testid": "registration-first-name"
    },
    domProps: {
      "value": (_vm.client.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.first_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.firstname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "firstnameError",
      "data-testid": "registration-first-name-error"
    }
  }, [_vm._v(_vm._s(_vm.clientError.firstname.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Příjmení:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.last_name),
      expression: "client.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "lastnameHelp",
      "id": "lastname",
      "data-testid": "registration-last-name"
    },
    domProps: {
      "value": (_vm.client.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.last_name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.lastname) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "lastnameError",
      "data-testid": "registration-last-name-error"
    }
  }, [_vm._v(_vm._s(_vm.clientError.lastname.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Pohlaví:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.gender),
      expression: "client.gender"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "genderHelp",
      "id": "gender",
      "data-testid": "registration-gender",
      "disabled": _vm.birthDateCalculated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("muž")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("žena")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("nezjištěno")])]), _vm._v(" "), (_vm.clientError.gender) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "genderError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.gender.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "birthdate"
    }
  }, [_vm._v("Datum narození:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.birth_date),
      expression: "client.birth_date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "birthdateHelp",
      "id": "birthdate",
      "data-testid": "registration-birth-date",
      "disabled": _vm.birthDateCalculated
    },
    domProps: {
      "value": (_vm.client.birth_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.birth_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.clientError.birthdate) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "birthdateError"
    }
  }, [_vm._v(_vm._s(_vm.clientError.birthdate.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceCompany"
    }
  }, [_vm._v("Zdravotní pojišťovna:")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "insuranceCompany",
      "data-testid": "registration-insurance-company",
      "props": "options",
      "options": _vm.insuranceCompanies,
      "track-by": "name",
      "label": "name",
      "placeholder": "vybrat pojišťovnu",
      "option-height": 104,
      "open-direction": "down",
      "custom-label": _vm.customLabel,
      "show-labels": false,
      "TagPlaceholder": "",
      "allow-empty": true,
      "disabled": _vm.insuranceFound,
      "selectLabel": ""
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "data-testid": 'registration-insurance-company-option-' + props.option.code
          }
        }, [_vm._v(_vm._s(_vm.customLabel(props.option)))])]
      }
    }]),
    model: {
      value: (_vm.selectedInsuranceCompany),
      callback: function($$v) {
        _vm.selectedInsuranceCompany = $$v
      },
      expression: "selectedInsuranceCompany"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ml-sm-2 mr-sm-2",
    attrs: {
      "for": "insuranceType"
    }
  }, [_vm._v("Druh: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.insurance.type),
      expression: "client.insurance.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "insuranceType",
      "data-testid": "registration-insurance-type",
      "disabled": _vm.insuranceFound
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.client.insurance.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((4), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " - " + _vm._s(_vm._f("insuranceTypeIntToName")(n)))])
  }))], 1)]), _vm._v(" "), (_vm.client.citizenship !== 1) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "insuranceNumber"
    }
  }, [_vm._v("Číslo pojištěnce:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.nationality),
      expression: "client.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "insuranceNumberHelp",
      "id": "insuranceNumber",
      "data-testid": "registration-insurance-number"
    },
    domProps: {
      "value": (_vm.client.nationality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.client.nationality = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.decodePinPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : (_vm.clientPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-submit"
    }
  }, [_vm._v("Zaregistrovat klienta")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])])])]) : _vm._e(), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(0)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c68e8e4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/components/RegistrationClient.vue
// module id = 459
// module chunks = 0